import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, Languages, Download, Zap, Shield, BarChart3 } from "lucide-react";
const Features = () => {
  const features = [{
    icon: Languages,
    title: "多语种识别",
    description: "支持泰语、越南语、日语、韩语、德语、法语、俄语、阿拉伯语（逐步增加中）等多种语言。"
  }, {
    icon: FileText,
    title: "格式智能还原",
    description: "保持、表格、图形、等原文档格式100%还原，确保专业性。"
  }, {
    icon: Download,
    title: "双语对照输出",
    description: "双语对照显示，支持多种格式导出，使用便捷。"
  }, {
    icon: Zap,
    title: "快速文件",
    description: "支持批量文档上传、多个文档同时处理，支持预览。"
  }, {
    icon: Shield,
    title: "API批量接入",
    description: "开放API，国际化支持，自动文档格式数据输入接口。"
  }, {
    icon: BarChart3,
    title: "数据安全合规",
    description: "高等级数据安全，未来可实现私有部署。"
  }];
  return <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-foreground mb-4">
            不只是翻译，更是格式还原与理解
          </h2>
          <p className="text-lg text-primary-foreground/80">分发处理→ 保留图谱，让文档有灵魂，智慧译。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => <Card key={index} className="border-primary-foreground/10 shadow-card hover:shadow-elegant transition-all duration-500 hover:-translate-y-2 hover:scale-105 bg-primary-foreground/5 backdrop-blur-sm group animate-fade-in" style={{
          animationDelay: `${index * 0.1}s`
        }}>
              <CardHeader className="pb-4">
                <div className="w-12 h-12 bg-primary-foreground/10 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg group-hover:shadow-glow">
                  <feature.icon className="w-6 h-6 text-primary-foreground group-hover:text-primary-foreground transition-colors duration-300" />
                </div>
                <CardTitle className="text-xl font-semibold text-primary-foreground group-hover:text-primary-foreground transition-colors duration-300">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-primary-foreground/70 leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
};
export default Features;